import { z } from 'zod'

/** 取得客戶資料by識別碼 Response Schema */
export const corporateNameByIdentifierDataSchema = z.object({
  /** BIZ_ID */
  bizId: z.string(),
  /** 客戶名稱[英文] */
  englishName: z.string(),
  /** 客戶名稱[當地語系] */
  localName: z.string(),
  /** 非會員綁定連結 */
  ffpRegisterUrl: z.string()
})

/** 取得客戶資料by識別碼 Response Schema */
export interface CorporateNameByIdentifierData extends z.infer<
  typeof corporateNameByIdentifierDataSchema
> {}
